<template>
    <div class="opinion">
        <van-nav-bar
                fixed
                title="财政司法意见征集"
                left-arrow
                @click-left="$router.go(-1)">
        </van-nav-bar>
        <div class="hhb-view">
            <detail-view v-model="info" :attrs="attrs" :opts="opts"/>
        </div>
    </div>
</template>

<script>
    import DetailView from "@/components/detail/index";

    export default {
        name: "opinion",
        components: {DetailView},
        data() {
            return {
                info: {},
                opts: {},
                attrs: [
                    {
                        body: [
                            {
                                type: 'table', name: 'datas', columns: [
                                    {title: '意见来源', field: 'source'},
                                    {title: '意见内容', field: 'content'},
                                ]
                            },
                            {
                                type: 'download',
                                name: 'items',
                                title: '补充材料：',
                                valueKey: 'dataUrl',
                                labelKey: 'dataTitle'
                            }
                        ]
                    }
                ]
            };
        },
        methods: {
            requestData() {
                this.info = {};
                this.$toast.loading('加载中...');
                this.request({
                    url: "/v1.0/Project/getProjectOpinion",
                    method: "get",
                    params: {
                        projectId: this.getId,
                    },
                }).then((res) => {
                    this.$toast.clear();
                    const {datas, fileDatas} = res.data;
                    const {items} = fileDatas || {};
                    this.$set(this.info, 'datas', datas);
                    this.$set(this.info, 'items', items);
                    // this.buildData();
                }).catch(() => {
                    this.$toast.clear();
                });
            }
        },
        computed: {
            getId() {
                return this.$route.query.id;
            }
        },
        created() {
            this.requestData();
        }
    }
</script>

<style lang="scss" scoped>
</style>